import { WebsiteLogo } from "../../hooks/useSettings";
import { Language, WebsiteDto } from "../../shared/types/websiteTypes";
import {
  SetActiveWeb,
  SetWebs,
  AddWeb,
  WebActionTypes,
  ClearWebs,
  SetPixelStatus,
} from "../types/web-types";

export const setActiveWeb = (url?: string, id?: string): SetActiveWeb => ({
  type: WebActionTypes.SET_ACTIVE_WEB,
  payload: { active: url, activeId: id },
});

export const setCustomWebLogo = (webLogo: WebsiteLogo) => ({
  type: WebActionTypes.SET_WEB_LOGO,
  payload: webLogo,
});

export const setWebs = (webs: WebsiteDto[]): SetWebs => ({
  type: WebActionTypes.SET_WEBS,
  payload: webs,
});

export const addWeb = (web: WebsiteDto): AddWeb => ({
  type: WebActionTypes.ADD_WEB,
  payload: web,
});

export const updateWeb = (
  id: string,
  name: string,
  url: string,
  language: Language,
) => ({
  type: WebActionTypes.UPDATE_WEB,
  payload: { id, name, url, language },
});

export const clearWebs = (): ClearWebs => ({
  type: WebActionTypes.CLEAR_WEBS,
});

export const setPixelStatus = (isConnected: boolean): SetPixelStatus => ({
  type: WebActionTypes.SET_PIXEL_STATUS,
  payload: isConnected,
});
